// actions.js
import * as actionTypes from "./actionsTypes";

export const setValuePindu = (value) => ({
  type: actionTypes.SET_VALUE_Pindu,
  payload: value,
});

export const setTypePindu = (type) => ({
  type: actionTypes.SET_TYPE_Pindu,
  payload: type,
});
export const setActifPindu = (actif) => ({
  type: actionTypes.SET_ACTIF_Pindu,
  payload: actif,
});

export const setCurrentPagePindu = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_Pindu,
  payload: page,
});

export const setOrderPindu = (order) => ({
  type: actionTypes.SET_ORDER_Pindu,
  payload: order,
});

export const setSortFieldPindu = (field) => ({
  type: actionTypes.SET_SORT_FIELD_Pindu,
  payload: field,
});
